import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yesNo'
})
export class YesNoPipe implements PipeTransform {

  /**
   * Transform boolean value to Yes/No string
   * @param value - The boolean value to transform
   * @returns 'Yes' if true, 'No' if false or null/undefined
   */
  transform(value: boolean | null | undefined): string {
    return value === true ? 'Yes' : 'No';
  }

}
